export default {
    horizontalMenuState: state => state.horizontalMenu,
    miniSidebarState: state => state.miniSidebarMenu,
    authUserState: state => state.authUser,
    referralCode: state => state.referralCode,
    posts: state => state.posts,
    post: (state) => (id) => state.posts.find(post => post.id === id),
    activeBlogPost: (state) => state.activeBlogPost,
    activePage: state => state.activePage,
    langState: state => state.lang,
    globalSearchState: state => state.globalSearch,
    bookmarkState: state => state.bookmark,
    langOptionState: state => state.langOption,
    colorState: state => state.colors,
    darkModeState: state => state.layoutMode.dark,
    rtlModeState: state => state.layoutMode.rtl,
    dualPackageState: state => state.dualPackageState,
}
